// eslint-disable-next-line import/prefer-default-export
export const contextClass = {
  success: 'green',
  error: 'red',
  warning: 'yellow',
};
